export const APIHOST = 'https://keepdoc.atlantico.digital'
// export const APIHOST = 'http://localhost:5000'
export const ALGOLIA_APP_ID = "6SOOPW9FC9"
export const ALGOLIA_API_KEY = "dd81b26cc66795cfd88ad96d96aeb2ab"